import { default as Image } from '@react/shared/components/Image';
import { AgentImageProps } from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentImage/AgentImage.types';
import Seniorly from 'sly/icons/Seniorly';
import { Link } from 'sly/system';

export default function AgentImage({
  gallery,
  displayName,
  mini,
  miniWidth,
  agentUrl,
}: AgentImageProps) {
  let imageUrl = '';
  if (gallery && gallery.images && gallery.images.length > 0) {
    imageUrl = gallery.images[0].path;
  }
  const hasNoImage = !imageUrl || imageUrl === '';
  return (
    <div
      className={`mx-auto mt-0 md:mb-4 ${
        mini ? miniWidth : 'w-[88px] md:w-[196px] lg:w-[var(--col3)]'
      }`}
      data-tp-id='gen-div-010cbce4-9cfa-414a-8a98-c89335e0e60f'
    >
      <Link to={agentUrl} target='_blank' rel='noreferrer'>
        {hasNoImage ? (
          <Seniorly />
        ) : (
          <div
            className='relative block h-0 w-full pt-[100%]'
            data-tp-id='gen-div-65786b95-3719-4c1c-aba5-fc57d210153c'
          >
            <Image
              path={imageUrl}
              layout='raw'
              height={200}
              width={200}
              alt={`${displayName} profile picture`}
              className='absolute top-0 left-0 h-full w-full rounded-[50%] object-cover'
              data-tp-id='gen-Image-8160c074-8eb0-480f-8575-759b01ae7ab9'
            />
          </div>
        )}
      </Link>
    </div>
  );
}
